import Immutable from 'immutable';

import {
	createState,
} from './simpleKeyStore';

import {
	get,
} from '~/model/api/API';



export const {
	reducer,
} = createState(
	'fetchingResponses',
	({
		key,
		websiteId,
	}) => {
		const [urlId, timestamp] = key.split('/');

		return get(
			'/websites/' + websiteId + '/pages/' + urlId + '/snapshots/' + timestamp,
		).then((snapshot) => Immutable.fromJS(snapshot));
	},
);
